import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import SettingsPage from './SettingsPage';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const featureFlags = useModuleFeatureFlag('settings');

  return (
    <Switch>
      <ProtectedRoute isAllowed={featureFlags.isEnabled} showPermission path="/settings" component={SettingsPage} />
    </Switch>
  );
};

export default Routes;
